(function () {
	function setTermsState(container) {
		if (!container) return;
		var checkbox = container.querySelector('[data-terms-checkbox]');
		if (!checkbox) return;

		var isChecked = checkbox.checked;
		var checkoutButtons = container.querySelectorAll('.checkout__button');
		checkoutButtons.forEach(function (button) {
			button.disabled = !isChecked;
			button.setAttribute('aria-disabled', String(!isChecked));
			button.classList.toggle('is-disabled', !isChecked);
		});

		var additionalButtons = container.querySelectorAll('.additional-checkout-buttons');
		additionalButtons.forEach(function (wrapper) {
			wrapper.classList.toggle('terms-disabled', !isChecked);
			wrapper.setAttribute('aria-disabled', String(!isChecked));
		});
	}

	function initTermsAcceptance(root) {
		var scope = root || document;
		var containers = scope.querySelectorAll('[data-terms-acceptance]');
		containers.forEach(function (container) {
			setTermsState(container);
		});
	}

	function initTopBarRotators(root) {
		var scope = root || document;
		var rotators = scope.querySelectorAll('[data-top-bar-rotator]');

		rotators.forEach(function (rotator) {
			if (rotator.dataset.rotatorInitialized === 'true') return;

			var slides = Array.prototype.slice.call(rotator.querySelectorAll('[data-top-bar-slide]'));
			if (!slides.length) return;

			var rotationMs = parseInt(rotator.getAttribute('data-rotation-ms'), 10);
			if (!rotationMs || rotationMs < 2000) {
				rotationMs = 5000;
			}

			var timerId = null;
			var activeIndex = 0;
			var circumference = 2 * Math.PI * 7;

			function resetProgress(slide) {
				var progress = slide.querySelector('[data-top-bar-progress]');
				if (!progress) return;

				progress.style.transition = 'none';
				progress.style.strokeDasharray = String(circumference);
				progress.style.strokeDashoffset = String(circumference);
			}

			function animateProgress(slide) {
				var progress = slide.querySelector('[data-top-bar-progress]');
				if (!progress) return;

				progress.getBoundingClientRect();
				progress.style.transition = 'stroke-dashoffset ' + rotationMs + 'ms linear';
				progress.style.strokeDashoffset = '0';
			}

			function scheduleNext() {
				if (timerId) {
					window.clearTimeout(timerId);
				}

				if (slides.length <= 1) return;

				timerId = window.setTimeout(function () {
					showSlide((activeIndex + 1) % slides.length);
				}, rotationMs);
			}

			function showSlide(index) {
				slides.forEach(function (slide, slideIndex) {
					var isActive = slideIndex === index;
					slide.classList.toggle('is-active', isActive);
					slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
					resetProgress(slide);
				});

				activeIndex = index;
				animateProgress(slides[activeIndex]);
				scheduleNext();
			}

			rotator.dataset.rotatorInitialized = 'true';
			showSlide(0);

			rotator._topBarRotatorDestroy = function () {
				if (timerId) {
					window.clearTimeout(timerId);
					timerId = null;
				}
			};
		});
	}

	function initTopBarCampaignGiftTriggers() {
		if (document.documentElement.dataset.topBarCampaignGiftBound === 'true') return;
		document.documentElement.dataset.topBarCampaignGiftBound = 'true';

		document.addEventListener('click', function (event) {
			var trigger = event.target && event.target.closest('[data-campaign-gift-open]');
			if (!trigger) return;

			document.dispatchEvent(new CustomEvent('campaign-gift:open'));
		});

		document.addEventListener('keydown', function (event) {
			if (event.key !== 'Enter' && event.key !== ' ') return;
			var trigger = event.target && event.target.closest('[data-campaign-gift-open]');
			if (!trigger) return;

			event.preventDefault();
			document.dispatchEvent(new CustomEvent('campaign-gift:open'));
		});
	}

	function getPresentmentGoalCents(baseGoalCents) {
		// data-goal-cents is rendered in the active market currency by Liquid.
		// Avoid converting again in JS, otherwise EUR markets get a double conversion.
		return Number(baseGoalCents) || 0;
	}

	var htmlEntityDecoder = null;

	function decodeHtmlEntities(value) {
		if (typeof value !== 'string') return value || '';
		if (value.indexOf('&') === -1) return value;
		if (!htmlEntityDecoder) {
			htmlEntityDecoder = document.createElement('textarea');
		}
		htmlEntityDecoder.innerHTML = value;
		return htmlEntityDecoder.value;
	}

	function getActiveCurrencyCode() {
		if (window.theme && window.theme.currencyCode) return window.theme.currencyCode;
		if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) return window.Shopify.currency.active;
		return 'USD';
	}

	function formatCampaignMoney(cents, withCurrencyCode) {
		var canUseThemeCurrency = typeof themeCurrency !== 'undefined' && themeCurrency && typeof themeCurrency.formatMoney === 'function';
		if (canUseThemeCurrency && window.theme && window.theme.moneyFormat) {
			var money = themeCurrency.formatMoney(cents, window.theme.moneyFormat);
			if (withCurrencyCode && window.theme && window.theme.currencyCode) {
				return money + ' ' + window.theme.currencyCode;
			}
			return money;
		}

		if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
			var fallbackMoney = window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}');
			if (withCurrencyCode && window.theme && window.theme.currencyCode) {
				return fallbackMoney + ' ' + window.theme.currencyCode;
			}
			return fallbackMoney;
		}

		try {
			var locale = (document.documentElement && document.documentElement.lang) ? document.documentElement.lang : 'en';
			var currencyCode = getActiveCurrencyCode();
			return new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: currencyCode,
				currencyDisplay: withCurrencyCode ? 'code' : 'symbol'
			}).format((Number(cents) || 0) / 100);
		} catch (error) {
			return ((Number(cents) || 0) / 100).toFixed(2) + (withCurrencyCode ? ' ' + getActiveCurrencyCode() : '');
		}
	}

	var campaignExcludedProductsByHandle = {};
	var campaignExcludedProductsPromises = {};
	var campaignExcludedProductIdsByTag = {};

	function isCampaignExcludedByTags(tagsValue) {
		var tags = [];
		if (typeof tagsValue === 'string') {
			tags = tagsValue.split(',');
		} else if (Array.isArray(tagsValue)) {
			tags = tagsValue;
		}

		if (!tags.length) return false;

		for (var i = 0; i < tags.length; i += 1) {
			var tag = String(tags[i] || '').trim().toLowerCase();
			if (tag === 'outlet' || tag === 'gift-card') {
				return true;
			}
		}

		return false;
	}

	function fetchCampaignExcludedProductByHandle(handle) {
		var normalizedHandle = (handle || '').trim();
		if (!normalizedHandle) return Promise.resolve(false);

		if (Object.prototype.hasOwnProperty.call(campaignExcludedProductsByHandle, normalizedHandle)) {
			return Promise.resolve(campaignExcludedProductsByHandle[normalizedHandle]);
		}

		if (campaignExcludedProductsPromises[normalizedHandle]) {
			return campaignExcludedProductsPromises[normalizedHandle];
		}

		campaignExcludedProductsPromises[normalizedHandle] = fetch('/products/' + normalizedHandle + '.js')
			.then(function (response) {
				if (!response.ok) {
					throw new Error('Failed to fetch product for campaign exclusion');
				}
				return response.json();
			})
			.then(function (product) {
				var excluded = isCampaignExcludedByTags(product && product.tags ? product.tags : '');
				campaignExcludedProductsByHandle[normalizedHandle] = excluded;

				if (excluded && product && product.id) {
					campaignExcludedProductIdsByTag[Number(product.id)] = true;
				}

				return excluded;
			})
			.catch(function () {
				campaignExcludedProductsByHandle[normalizedHandle] = false;
				return false;
			});

		return campaignExcludedProductsPromises[normalizedHandle];
	}

	function preloadCampaignExcludedProductsFromCart(cart) {
		if (!cart || !cart.items || !cart.items.length) {
			return Promise.resolve();
		}

		var productRequests = [];
		cart.items.forEach(function (item) {
			if (!item) return;

			if (item.gift_card && item.product_id) {
				campaignExcludedProductIdsByTag[Number(item.product_id)] = true;
			}

			var handle = (item.handle || '').trim();
			if (handle) {
				productRequests.push(fetchCampaignExcludedProductByHandle(handle));
			}
		});

		if (!productRequests.length) {
			return Promise.resolve();
		}

		return Promise.all(productRequests).then(function () {});
	}

	function isCampaignExcludedCartItem(item) {
		if (!item) return false;

		if (item.gift_card) return true;

		var productId = Number(item.product_id);
		if (productId > 0 && campaignExcludedProductIdsByTag[productId]) {
			return true;
		}

		var productType = String(item.product_type || '').trim().toLowerCase();
		if (productType === 'gift card' || productType === 'gift-card') {
			return true;
		}

		var handle = (item.handle || '').trim();
		if (handle && Object.prototype.hasOwnProperty.call(campaignExcludedProductsByHandle, handle)) {
			return campaignExcludedProductsByHandle[handle] === true;
		}

		return false;
	}

	function calculateCampaignEligibleSubtotal(cart, giftVariantId) {
		var subtotal = 0;
		if (cart && cart.items && cart.items.length) {
			cart.items.forEach(function (item) {
				if (giftVariantId > 0 && Number(item.variant_id) === giftVariantId) return;
				if (isCampaignExcludedCartItem(item)) return;
				// Use line_price (before discounts) not final_line_price (after discounts)
				// to calculate the correct campaign goal eligibility
				subtotal += Number(item.line_price || 0);
			});
			return subtotal;
		}
		return Number((cart && (cart.items_subtotal_price || cart.total_price)) || 0);
	}

	function initCartDrawerCampaignGiftProgress(rootNode) {
		var scope = rootNode || document;
		var triggers = scope.querySelectorAll('[data-cart-campaign-gift-trigger]');
		if (!triggers.length) return;

		var circumference = 28 * Math.PI;

		function parseDate(value, isEndDate) {
			if (!value) return null;
			if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
				var parts = value.split('-');
				var day = parseInt(parts[0], 10);
				var month = parseInt(parts[1], 10) - 1;
				var year = parseInt(parts[2], 10);
				if (isEndDate) {
					return new Date(year, month, day, 23, 59, 59, 999);
				}
				return new Date(year, month, day, 0, 0, 0, 0);
			}
			return new Date(value);
		}

		function isCampaignActive(trigger) {
			var now = new Date();
			var startDateValue = (trigger.getAttribute('data-start-date') || '').trim();
			var endDateValue = (trigger.getAttribute('data-end-date') || '').trim();
			var startDate = parseDate(startDateValue, false);
			var endDate = parseDate(endDateValue, true);

			if (startDate && !isNaN(startDate) && now < startDate) return false;
			if (endDate && !isNaN(endDate) && now > endDate) return false;
			return true;
		}

		function setProgress(progressNode, percent) {
			if (!progressNode) return;
			var normalized = Math.max(0, Math.min(100, Number(percent) || 0));
			var offset = circumference - normalized / 100 * circumference / 2;
			progressNode.style.strokeDashoffset = String(offset);
		}

		function updateTrigger(trigger, cart) {
			if (!trigger) return;
			if (!isCampaignActive(trigger)) {
				trigger.hidden = true;
				return;
			}
			trigger.hidden = false;

			var progressNode = trigger.querySelector('[data-cart-campaign-gift-progress]');
			var messageNode = trigger.querySelector('[data-cart-campaign-gift-message]');

			var goalCentsBase = parseInt(trigger.getAttribute('data-goal-cents') || '0', 10);
			var goalCents = getPresentmentGoalCents(goalCentsBase);
			var remainingTemplate = decodeHtmlEntities(trigger.getAttribute('data-remaining-template') || '__AMOUNT__');
			var qualifiedMessage = decodeHtmlEntities(trigger.getAttribute('data-qualified-message') || '');
			var useCurrencyCode = trigger.getAttribute('data-currency-code-enabled') === 'true';
			var giftVariantId = parseInt(trigger.getAttribute('data-gift-variant-id') || '0', 10);
			if (!goalCents) {
				setProgress(progressNode, 0);
				return;
			}

			var subtotal = calculateCampaignEligibleSubtotal(cart, giftVariantId);
			var percent = subtotal / goalCents * 100;
			var left = Math.max(0, goalCents - subtotal);
			setProgress(progressNode, percent);

			if (messageNode) {
				if (left > 0) {
					messageNode.textContent = remainingTemplate.split('__AMOUNT__').join(formatCampaignMoney(left, useCurrencyCode));
				} else {
					messageNode.textContent = qualifiedMessage;
				}
			}
		}

		triggers.forEach(function (trigger) {
			if (!isCampaignActive(trigger)) {
				trigger.hidden = true;
				return;
			}
			var progressNode = trigger.querySelector('[data-cart-campaign-gift-progress]');
			if (!progressNode) return;
			setProgress(progressNode, parseFloat(progressNode.getAttribute('data-percent') || '0'));
		});

		var preloadPromise = Promise.resolve();

		if (document.documentElement.dataset.cartCampaignGiftBound !== 'true') {
			document.documentElement.dataset.cartCampaignGiftBound = 'true';

			function refreshTriggers(cart) {
				document.querySelectorAll('[data-cart-campaign-gift-trigger]').forEach(function (trigger) {
					updateTrigger(trigger, cart);
				});
			}

			function fetchAndRefreshTriggers() {
				fetch((window.theme && window.theme.routes ? window.theme.routes.cart : '/cart') + '.js')
					.then(function (response) { return response.json(); })
					.then(function (cart) {
						return preloadCampaignExcludedProductsFromCart(cart).then(function () {
							refreshTriggers(cart);
						});
					})
					.catch(function () {});
			}

			document.addEventListener('theme:cart:change', function (event) {
				var cart = event && event.detail ? event.detail.cart : null;
				if (cart) {
					preloadCampaignExcludedProductsFromCart(cart).then(function () {
						refreshTriggers(cart);
					});
					return;
				}
				fetchAndRefreshTriggers();
			});

			document.addEventListener('theme:cart:reload', fetchAndRefreshTriggers);

			preloadPromise.then(fetchAndRefreshTriggers);
		}
	}

	function initCampaignGift(rootNode) {
		var scope = rootNode || document;
		var root = scope.querySelector('[data-campaign-gift]');
		if (!root) return;
		if (root.dataset.campaignGiftInitialized === 'true') return;

		var launcher = root.querySelector('[data-campaign-gift-launcher]');
		var closeBtn = root.querySelector('[data-campaign-gift-close]');
		var status = root.querySelector('[data-campaign-gift-status]');
		var progressBar = root.querySelector('[data-campaign-gift-progress]');
		var addBtn = root.querySelector('[data-campaign-gift-add]');
		var disclaimer = root.querySelector('[data-campaign-gift-disclaimer]');
		var readmoreBtn = root.querySelector('[data-campaign-gift-readmore]');
		var readmoreInitialized = false;

		if (!launcher || !closeBtn || !status || !progressBar) return;

		root.dataset.campaignGiftInitialized = 'true';
		root.classList.add('campaign-gift--ready');

		var goalCentsBase = parseInt(root.getAttribute('data-goal-cents') || '0', 10);
		var giftVariantId = parseInt(root.getAttribute('data-gift-variant-id') || '0', 10);
		var hideHours = parseInt(root.getAttribute('data-hide-hours') || '24', 10);
		var autoOpenSetting = (root.getAttribute('data-auto-open') || 'true').trim().toLowerCase();
		var autoOpen = autoOpenSetting !== 'false' && autoOpenSetting !== '0';
		var startDateValue = (root.getAttribute('data-start-date') || '').trim();
		var endDateValue = (root.getAttribute('data-end-date') || '').trim();
		var progressMessage = decodeHtmlEntities(root.getAttribute('data-progress-message') || 'Læg ||amount|| mere i kurven for at få gaven');
		var reachedMessage = decodeHtmlEntities(root.getAttribute('data-reached-message') || 'Du har låst op for din gratis gave');
		var readMoreLabel = root.getAttribute('data-read-more-label') || 'Læs mere';
		var readLessLabel = root.getAttribute('data-read-less-label') || 'Læs mindre';
		var addGiftLabel = root.getAttribute('data-add-gift-label') || 'Tilføj gave';
		var addedLabel = root.getAttribute('data-added-label') || 'Tilføjet';
		var addingLabel = root.getAttribute('data-adding-label') || 'Tilføjer...';
		var retryLabel = root.getAttribute('data-retry-label') || 'Prøv igen';
		var dismissStorageKey = 'campaign_gift_dismissed_until_' + (endDateValue || 'default').replace(/-/g, '');
		var dismissCookieName = dismissStorageKey;
		var isAutoAddingGift = false;
		var isAutoRemovingGift = false;
		var cartSyncTimeouts = [];
		var cartFetchRequestId = 0;
		var manualRemovalStorageKey = 'campaign_gift_manually_removed_' + giftVariantId;
		var lastKnownQualified = false;

		function parseDate(value, isEndDate) {
			if (!value) return null;
			if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
				var parts = value.split('-');
				var day = parseInt(parts[0], 10);
				var month = parseInt(parts[1], 10) - 1;
				var year = parseInt(parts[2], 10);
				if (isEndDate) {
					return new Date(year, month, day, 23, 59, 59, 999);
				}
				return new Date(year, month, day, 0, 0, 0, 0);
			}
			return new Date(value);
		}

		function isCampaignActive() {
			if (window.Shopify && window.Shopify.designMode) {
				return true;
			}

			var now = new Date();
			var startDate = parseDate(startDateValue, false);
			var endDate = parseDate(endDateValue, true);

			if (startDate && !isNaN(startDate) && now < startDate) return false;
			if (endDate && !isNaN(endDate) && now > endDate) return false;
			return true;
		}

		function getCookie(name) {
			var nameEq = name + '=';
			var cookies = document.cookie ? document.cookie.split(';') : [];
			for (var i = 0; i < cookies.length; i += 1) {
				var cookie = cookies[i].trim();
				if (cookie.indexOf(nameEq) === 0) {
					return decodeURIComponent(cookie.substring(nameEq.length));
				}
			}
			return '';
		}

		function getDismissedUntil() {
			var value = '';

			try {
				value = window.localStorage.getItem(dismissStorageKey) || '';
			} catch (error) {}

			if (!value) {
				value = getCookie(dismissCookieName) || '';
			}

			var dismissedUntil = parseInt(value, 10);
			return isNaN(dismissedUntil) ? 0 : dismissedUntil;
		}

		function setDismissedUntil(timestamp) {
			var value = String(timestamp);
			var maxAge = Math.max(0, Math.floor((timestamp - Date.now()) / 1000));

			try {
				window.localStorage.setItem(dismissStorageKey, value);
			} catch (error) {}

			document.cookie = dismissCookieName + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
		}

		function setManuallyRemoved(value) {
			try {
				if (value) {
					window.sessionStorage.setItem(manualRemovalStorageKey, 'true');
				} else {
					window.sessionStorage.removeItem(manualRemovalStorageKey);
				}
			} catch (error) {}
		}

		function wasManuallyRemoved() {
			try {
				return window.sessionStorage.getItem(manualRemovalStorageKey) === 'true';
			} catch (error) {
				return false;
			}
		}

		function dismissForConfiguredHours() {
			var hours = hideHours;
			if (isNaN(hours) || hours <= 0) {
				hours = 24;
			}
			var dismissedUntil = Date.now() + hours * 60 * 60 * 1000;
			setDismissedUntil(dismissedUntil);
		}

		function isDismissed() {
			return Date.now() < getDismissedUntil();
		}

		function autoAddGift() {
			if (giftVariantId <= 0 || isAutoAddingGift || isAutoRemovingGift) return;

			var didMutateCart = false;
			isAutoAddingGift = true;
			fetch(window.theme.routes.cart_add_url + '.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					id: giftVariantId,
					quantity: 1
				})
			})
				.then(function (response) {
					if (!response.ok) {
						throw new Error('Auto add gift failed');
					}
					didMutateCart = true;
					// Clear manual removal flag since gift was successfully auto-added
					setManuallyRemoved(false);
					return response.json();
				})
				.then(function (addedItem) {
					document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
						detail: {
							variant: {
								id: addedItem && addedItem.variant_id ? addedItem.variant_id : giftVariantId
							}
						},
						bubbles: true
					}));
					return fetchCart();
				})
				.then(function (cart) {
					notifyThemeCartUpdated(cart);
				})
				.catch(function () {})
				.then(function () {
					isAutoAddingGift = false;
					if (didMutateCart) {
						scheduleCartSync();
					}
				});
		}

		function autoRemoveGift(cart) {
			if (giftVariantId <= 0 || isAutoRemovingGift || isAutoAddingGift) return;

			var giftLineItem = null;
			var giftLineNumbers = [];
			if (cart && cart.items && cart.items.length) {
				cart.items.forEach(function (item, index) {
					if (Number(item.variant_id) === giftVariantId) {
						giftLineNumbers.push(index + 1);
						if (!giftLineItem) giftLineItem = item;
					}
				});
			}

			if (!giftLineNumbers.length && !giftLineItem) return;

			var changeTargetId = giftLineItem && giftLineItem.key ? giftLineItem.key : giftVariantId;

			var didMutateCart = false;
			isAutoRemovingGift = true;

			var removeByLine = giftLineNumbers
				.sort(function (a, b) { return b - a; })
				.reduce(function (promise, lineNumber) {
					return promise.then(function () {
						return fetch('/cart/change.js', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								line: lineNumber,
								quantity: 0
							})
						}).then(function (response) {
							if (!response.ok) {
								throw new Error('Auto remove gift by line failed');
							}
							didMutateCart = true;
							return response.json();
						});
					});
				}, Promise.resolve());

			removeByLine
				.catch(function () {
					return fetch('/cart/change.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							id: changeTargetId,
							quantity: 0
						})
					}).then(function (response) {
						if (!response.ok) {
							throw new Error('Auto remove gift fallback failed');
						}
						didMutateCart = true;
						return response.json();
					});
				})
				.then(function () {
					return fetchCart();
				})
				.then(function (cart) {
					notifyThemeCartUpdated(cart);
				})
				.catch(function () {})
				.then(function () {
					isAutoRemovingGift = false;
					if (didMutateCart) {
						scheduleCartSync();
					}
				});
		}

		function setOpenState(isOpen) {
			root.classList.toggle('is-open', isOpen);
			launcher.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

			if (isOpen) {
				requestAnimationFrame(function () {
					initReadMore();
				});
			}
		}

		function initReadMore() {
			if (!disclaimer || !readmoreBtn) return;
			if (!root.classList.contains('is-open')) return;

			root.classList.remove('is-legal-expanded');
			root.classList.add('is-legal-collapsed');

			var isLongText = disclaimer.scrollHeight > disclaimer.clientHeight + 2;

			if (!isLongText) {
				readmoreBtn.hidden = true;
				root.classList.remove('is-legal-collapsed');
				root.classList.remove('is-legal-expanded');
				return;
			}

			readmoreBtn.hidden = false;
			readmoreBtn.textContent = readMoreLabel;
			readmoreBtn.setAttribute('aria-expanded', 'false');

			if (!readmoreInitialized) {
				readmoreBtn.addEventListener('click', function () {
					var isExpanded = root.classList.contains('is-legal-expanded');

					if (isExpanded) {
						root.classList.remove('is-legal-expanded');
						root.classList.add('is-legal-collapsed');
					} else {
						root.classList.add('is-legal-expanded');
						root.classList.remove('is-legal-collapsed');
					}

					isExpanded = root.classList.contains('is-legal-expanded');
					readmoreBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
					readmoreBtn.textContent = isExpanded ? readLessLabel : readMoreLabel;
				});

				readmoreInitialized = true;
			}
		}

		function updateFromCart(cart) {
			var goalCents = getPresentmentGoalCents(goalCentsBase);
			var subtotal = calculateCampaignEligibleSubtotal(cart, giftVariantId);
			var progress = goalCents > 0 ? Math.min(100, Math.max(0, (subtotal / goalCents) * 100)) : 0;
			progressBar.style.width = progress + '%';

			var left = Math.max(0, goalCents - subtotal);
			var isQualified = left <= 0;
			var alreadyAdded = false;
			if (giftVariantId > 0 && cart && cart.items && cart.items.length) {
				alreadyAdded = cart.items.some(function (item) {
					return Number(item.variant_id) === giftVariantId;
				});
			}

			if (left > 0) {
				status.textContent = progressMessage
					.replace('||amount||', formatCampaignMoney(left, false))
					.replace(/\{\{\s*amount\s*\}\}/g, formatCampaignMoney(left, false));
				root.classList.remove('is-qualified');
			} else {
				status.textContent = reachedMessage;
				root.classList.add('is-qualified');
			}

			if (addBtn) {
				if (alreadyAdded) {
					addBtn.disabled = true;
					addBtn.textContent = addedLabel;
				} else if (isQualified) {
					addBtn.disabled = false;
					addBtn.textContent = addGiftLabel;
				} else {
					addBtn.disabled = true;
					addBtn.textContent = addGiftLabel;
				}
			}

			// Clear manual removal flag if they drop below threshold
			if (!isQualified && lastKnownQualified) {
				setManuallyRemoved(false);
			}
			lastKnownQualified = isQualified;

			// Only auto-add if qualified, not already added, and wasn't manually removed
			if (isQualified && !alreadyAdded && !wasManuallyRemoved()) {
				autoAddGift();
			}

			// Don't auto-remove the gift anymore - let customers keep it if they want
		}

		function fetchCart() {
			var requestId = ++cartFetchRequestId;
			return fetch((window.theme && window.theme.routes ? window.theme.routes.cart : '/cart') + '.js')
				.then(function (response) { return response.json(); })
				.then(function (cart) {
					return preloadCampaignExcludedProductsFromCart(cart).then(function () {
						return cart;
					});
				})
				.then(function (cart) {
					if (requestId !== cartFetchRequestId) {
						return cart;
					}
					updateFromCart(cart);
					return cart;
				})
				.catch(function () {});
		}

		function clearCartSyncTimeouts() {
			if (!cartSyncTimeouts.length) return;
			cartSyncTimeouts.forEach(function (timeoutId) {
				window.clearTimeout(timeoutId);
			});
			cartSyncTimeouts = [];
		}

		function scheduleCartSync(includeImmediate) {
			clearCartSyncTimeouts();

			if (includeImmediate !== false) {
				fetchCart();
			}

			[300, 900, 1800].forEach(function (delay) {
				var timeoutId = window.setTimeout(function () {
					fetchCart();
				}, delay);
				cartSyncTimeouts.push(timeoutId);
			});
		}

		function notifyThemeCartUpdated(cart) {
			if (cart) {
				document.dispatchEvent(new CustomEvent('theme:cart:change', {
					detail: { cart: cart },
					bubbles: true
				}));
			}

			document.dispatchEvent(new CustomEvent('theme:cart:reload', {
				bubbles: true
			}));
		}

		var autoOpenTimerId = null;
		var CAMPAIGN_GIFT_AUTO_OPEN_MS = 5000;

		function cancelAutoOpenTimer() {
			if (autoOpenTimerId) {
				window.clearTimeout(autoOpenTimerId);
				autoOpenTimerId = null;
			}
		}

		function handleCampaignGiftOpenEvent() {
			cancelAutoOpenTimer();
			setOpenState(true);
		}

		if (root.getAttribute('data-campaign-active') !== 'true' || !isCampaignActive()) {
			root.hidden = true;
			return;
		}

		root.hidden = false;
		fetchCart().then(function () {
			scheduleCartSync();
		});

		if (autoOpen) {
			autoOpenTimerId = window.setTimeout(function () {
				autoOpenTimerId = null;
				if (!isDismissed()) {
					setOpenState(true);
				}
			}, CAMPAIGN_GIFT_AUTO_OPEN_MS);
		}

		launcher.addEventListener('click', function () {
			var isOpen = root.classList.contains('is-open');
			setOpenState(!isOpen);

			if (isOpen) {
				dismissForConfiguredHours();
			}
		});

		document.addEventListener('campaign-gift:open', handleCampaignGiftOpenEvent);

		closeBtn.addEventListener('click', function () {
			cancelAutoOpenTimer();
			setOpenState(false);
			dismissForConfiguredHours();
		});

		if (addBtn && giftVariantId > 0) {
			addBtn.addEventListener('click', function () {
				if (addBtn.disabled) return;

				addBtn.disabled = true;
				addBtn.textContent = addingLabel;

				fetch(window.theme.routes.cart_add_url + '.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						id: giftVariantId,
						quantity: 1
					})
				})
					.then(function (response) {
						if (!response.ok) {
							throw new Error('Add to cart failed');
						}
						return response.json();
					})
					.then(function (addedItem) {
						// Clear manual removal flag when gift is manually added
						setManuallyRemoved(false);
						
						document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
							detail: {
								variant: {
									id: addedItem && addedItem.variant_id ? addedItem.variant_id : giftVariantId
								}
							},
							bubbles: true
						}));
						return fetchCart();
					})
					.then(function (cart) {
						if (cart) {
							document.dispatchEvent(new CustomEvent('theme:cart:change', {
								detail: { cart: cart },
								bubbles: true
							}));
						}

						setOpenState(false);
						dismissForConfiguredHours();
					})
					.catch(function () {
						addBtn.disabled = false;
						addBtn.textContent = retryLabel;
					});
			});
		}

		document.addEventListener('theme:cart:change', function (event) {
			if (event && event.detail && event.detail.cart) {
				var cart = event.detail.cart;
				preloadCampaignExcludedProductsFromCart(cart).then(function () {
					// Check if gift was in the cart before this change
					var giftStillInCart = false;
					if (cart && cart.items && cart.items.length) {
						giftStillInCart = cart.items.some(function (item) {
							return Number(item.variant_id) === giftVariantId;
						});
					}

					// If gift was removed and we're qualified, mark as manually removed
					var goalCents = getPresentmentGoalCents(goalCentsBase);
					var subtotal = calculateCampaignEligibleSubtotal(cart, giftVariantId);
					var isQualified = subtotal >= goalCents;

					if (!giftStillInCart && isQualified && lastKnownQualified) {
						setManuallyRemoved(true);
					}

					updateFromCart(cart);
					scheduleCartSync(false);
				});
				return;
			}

			scheduleCartSync();
		});

		document.addEventListener('theme:cart:reload', function () {
			scheduleCartSync();
		});

		document.addEventListener('theme:cart:popdown', function () {
			scheduleCartSync();
		});
	}

	function initProductCampaignGiftInfo(rootNode) {
		var scope = rootNode || document;
		var items = scope.querySelectorAll('[data-product-campaign-gift-info]');
		if (!items.length) return;

		function parseDate(value, isEndDate) {
			if (!value) return null;
			if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
				var parts = value.split('-');
				var day = parseInt(parts[0], 10);
				var month = parseInt(parts[1], 10) - 1;
				var year = parseInt(parts[2], 10);
				if (isEndDate) {
					return new Date(year, month, day, 23, 59, 59, 999);
				}
				return new Date(year, month, day, 0, 0, 0, 0);
			}
			return new Date(value);
		}

		function isCampaignActive(el) {
			var now = new Date();
			var startDateValue = (el.getAttribute('data-start-date') || '').trim();
			var endDateValue = (el.getAttribute('data-end-date') || '').trim();
			var startDate = parseDate(startDateValue, false);
			var endDate = parseDate(endDateValue, true);

			if (startDate && !isNaN(startDate) && now < startDate) return false;
			if (endDate && !isNaN(endDate) && now > endDate) return false;
			return true;
		}

		function updateItem(el, cart) {
			var textNode = el.querySelector('[data-product-campaign-gift-text]');
			var progressNode = el.querySelector('[data-product-campaign-gift-progress]');
			if (!textNode) return;

			var remainingTemplate = decodeHtmlEntities(el.getAttribute('data-remaining-template') || '__AMOUNT__');
			var qualifiedMessage = decodeHtmlEntities(el.getAttribute('data-qualified-message') || '');
			var clickHereLabel = decodeHtmlEntities(el.getAttribute('data-click-here-label') || '');
			var goalCentsBase = parseInt(el.getAttribute('data-goal-cents') || '0', 10);
			var goalCents = getPresentmentGoalCents(goalCentsBase);
			var giftVariantId = parseInt(el.getAttribute('data-gift-variant-id') || '0', 10);
			var subtotal = calculateCampaignEligibleSubtotal(cart, giftVariantId);
			var left = Math.max(0, goalCents - subtotal);
			var progress = goalCents > 0 ? Math.min(100, Math.max(0, (subtotal / goalCents) * 100)) : 0;

			if (progressNode) {
				progressNode.style.width = progress + '%';
			}

			if (left > 0) {
				el.classList.remove('is-qualified');
				textNode.textContent = remainingTemplate.split('__AMOUNT__').join(formatCampaignMoney(left, false));
			} else {
				el.classList.add('is-qualified');
				textNode.textContent = qualifiedMessage + ' ';

				var linkNode = document.createElement('span');
				linkNode.className = 'product__campaign-gift-link';
				linkNode.appendChild(document.createTextNode(clickHereLabel + ' '));
				linkNode.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M3 8h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
				textNode.appendChild(linkNode);
			}
		}

		function fetchCartAndUpdate(el) {
			return fetch((window.theme && window.theme.routes ? window.theme.routes.cart : '/cart') + '.js')
				.then(function (response) { return response.json(); })
				.then(function (cart) {
					return preloadCampaignExcludedProductsFromCart(cart).then(function () {
						updateItem(el, cart);
						return cart;
					});
				})
				.then(function (cart) {
					return cart;
				})
				.catch(function () {});
		}

		items.forEach(function (el) {
			if (el.dataset.campaignGiftInit === 'true') return;
			el.dataset.campaignGiftInit = 'true';

			if (!isCampaignActive(el)) {
				el.hidden = true;
				return;
			}

			el.hidden = false;
			fetchCartAndUpdate(el);

			el.addEventListener('click', function () {
				document.dispatchEvent(new CustomEvent('campaign-gift:open', { bubbles: true }));
			});

			document.addEventListener('theme:cart:change', function (event) {
				if (event && event.detail && event.detail.cart) {
					preloadCampaignExcludedProductsFromCart(event.detail.cart).then(function () {
						updateItem(el, event.detail.cart);
					});
					return;
				}
				fetchCartAndUpdate(el);
			});

			document.addEventListener('theme:cart:reload', function () {
				fetchCartAndUpdate(el);
			});
		});
	}

	function initSerierAlphabetNav(rootNode) {
		var scope = rootNode || document;
		var navs = scope.querySelectorAll('[data-serier-alphabet-nav]');
		if (!navs.length) return;

		navs.forEach(function (nav) {
			if (nav.dataset.serierInitialized === 'true') return;
			nav.dataset.serierInitialized = 'true';

			var offset = parseInt(nav.getAttribute('data-serier-offset') || '24', 10);
			nav.querySelectorAll('.serier-alphabet-btn:not(.serier-alphabet-btn--disabled)').forEach(function (btn) {
				btn.addEventListener('click', function () {
					var letter = this.dataset.letter;
					var target = document.getElementById('series-letter-' + letter);
					if (target) {
						var header = document.querySelector('.site-header, header[role="banner"]');
						var headerHeight = header ? header.offsetHeight : 80;
						var y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - offset;
						window.scrollTo({ top: y, behavior: 'smooth' });
					}

					nav.querySelectorAll('.serier-alphabet-btn').forEach(function (button) {
						button.classList.remove('serier-alphabet-btn--active');
					});
					this.classList.add('serier-alphabet-btn--active');
				});
			});
		});
	}

	function initEnergyLabelLinks(rootNode) {
		var scope = rootNode || document;
		var blocks = scope.querySelectorAll('.product__block__energy-label');
		if (!blocks.length) return;

		function validateUrl(url, onValid) {
			if (!url) return;
			fetch(url, { method: 'HEAD' })
				.then(function (response) {
					if (!response.ok) return;
					onValid();
				})
				.catch(function () {});
		}

		blocks.forEach(function (block) {
			if (block.dataset.energyLabelInit === 'true') return;
			block.dataset.energyLabelInit = 'true';

			var labelLink = block.querySelector('[data-energy-label-link]');
			var ficheLink = block.querySelector('[data-energy-fiche-link]');

			if (labelLink) {
				var labelUrl = (labelLink.getAttribute('data-energy-label-url') || '').trim();
				validateUrl(labelUrl, function () {
					labelLink.href = labelUrl;
					labelLink.target = '_blank';
					labelLink.rel = 'noopener';
				});
			}

			if (ficheLink) {
				var ficheUrl = (ficheLink.getAttribute('data-energy-fiche-url') || ficheLink.getAttribute('href') || '').trim();
				validateUrl(ficheUrl, function () {
					ficheLink.hidden = false;
				});
			}
		});
	}

	function initProductImageClickToZoom(rootNode) {
		var scope = rootNode || document;
		var wrappers = scope.querySelectorAll('.product__media[data-type="image"] .product-image-wrapper');
		if (!wrappers.length) return;

		wrappers.forEach(function (wrapper) {
			if (wrapper.dataset.imageZoomInit === 'true') return;

			var mediaSlide = wrapper.closest('[data-media-slide]');
			if (!mediaSlide) return;

			var zoomButton = mediaSlide.querySelector('[data-zoom-button]');
			if (!zoomButton) return;

			wrapper.dataset.imageZoomInit = 'true';
			wrapper.tabIndex = 0;
			wrapper.setAttribute('role', 'button');
			wrapper.setAttribute('aria-label', 'Zoom image');

			wrapper.addEventListener('click', function (event) {
				if (!window.matchMedia('(min-width: 768px)').matches) return;
				if (event.target.closest('[data-size-button], [data-zoom-button], button, a, input, select, textarea, label')) return;
				zoomButton.click();
			});

			wrapper.addEventListener('keydown', function (event) {
				if (!window.matchMedia('(min-width: 768px)').matches) return;
				if (event.key !== 'Enter' && event.key !== ' ') return;
				event.preventDefault();
				zoomButton.click();
			});
		});
	}

	var measurementLightboxScriptPromise = null;

	function ensureMeasurementLightboxScript() {
		if (window.themePhotoswipe && window.themePhotoswipe.PhotoSwipe && window.themePhotoswipe.PhotoSwipeUI) {
			return Promise.resolve();
		}

		if (measurementLightboxScriptPromise) {
			return measurementLightboxScriptPromise;
		}

		var photoswipeUrl = window.theme && window.theme.assets ? window.theme.assets.photoswipe : null;
		if (!photoswipeUrl) {
			return Promise.reject(new Error('PhotoSwipe asset url not found'));
		}

		measurementLightboxScriptPromise = new Promise(function (resolve, reject) {
			var existing = document.querySelector('script[data-measurement-pswp]');
			if (existing) {
				existing.addEventListener('load', function () { resolve(); }, { once: true });
				existing.addEventListener('error', function () { reject(new Error('Failed to load PhotoSwipe')); }, { once: true });
				return;
			}

			var script = document.createElement('script');
			script.src = photoswipeUrl;
			script.async = true;
			script.setAttribute('data-measurement-pswp', 'true');
			script.onload = function () { resolve(); };
			script.onerror = function () { reject(new Error('Failed to load PhotoSwipe')); };
			document.head.appendChild(script);
		});

		return measurementLightboxScriptPromise;
	}

	function initMeasurementLightbox(rootNode) {
		var scope = rootNode || document;
		var links = scope.querySelectorAll('[data-measurement-lightbox]');
		if (!links.length) return;

		links.forEach(function (link) {
			if (link.dataset.measurementLightboxInit === 'true') return;
			link.dataset.measurementLightboxInit = 'true';

			link.addEventListener('click', function (event) {
				event.preventDefault();

				var wrapper = document.querySelector('[data-zoom-wrapper]');
				var href = link.getAttribute('href');
				if (!wrapper || !href) {
					if (href) {
						window.open(href, '_blank', 'noopener');
					}
					return;
				}

				var src = link.getAttribute('data-pswp-src') || href;
				var w = parseInt(link.getAttribute('data-pswp-width') || '1600', 10);
				var h = parseInt(link.getAttribute('data-pswp-height') || '1600', 10);

				ensureMeasurementLightboxScript().then(function () {
					if (!window.themePhotoswipe || !window.themePhotoswipe.PhotoSwipe || !window.themePhotoswipe.PhotoSwipeUI) {
						window.open(href, '_blank', 'noopener');
						return;
					}

					var PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
					var PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
					var items = [{ src: src, w: isNaN(w) ? 1600 : w, h: isNaN(h) ? 1600 : h }];

					wrapper.dispatchEvent(new CustomEvent('theme:scroll:lock', {
						bubbles: true
					}));

					var gallery = new PhotoSwipe(wrapper, PhotoSwipeUI, items, {
						index: 0,
						showHideOpacity: true,
						showAnimationDuration: 150,
						hideAnimationDuration: 250,
						bgOpacity: 1,
						history: false,
						loop: false,
						closeOnScroll: false,
						closeOnVerticalDrag: true
					});

					gallery.init();
					gallery.listen('close', function () {
						document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
							bubbles: true
						}));
					});
				}).catch(function () {
					window.open(href, '_blank', 'noopener');
				});
			});
		});
	}


	function destroyDeliveryEstimate(block) {
		if (!block) return;
		if (typeof block._deliveryEstimateCleanup === 'function') {
			block._deliveryEstimateCleanup();
			block._deliveryEstimateCleanup = null;
		}
		delete block.dataset.deliveryEstimateInit;
	}

	function getZonedDateParts(timeZone) {
		var parts = new Intl.DateTimeFormat('en-US', {
			timeZone: timeZone,
			weekday: 'short',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
			hour12: false
		}).formatToParts(new Date());

		var map = {};
		parts.forEach(function (part) {
			if (part.type !== 'literal') {
				map[part.type] = part.value;
			}
		});

		return {
			weekday: map.weekday,
			hour: parseInt(map.hour, 10),
			minute: parseInt(map.minute, 10),
			second: parseInt(map.second, 10)
		};
	}

	function isSameDayShippingWeekday(weekday) {
		return weekday !== 'Sat' && weekday !== 'Sun';
	}

	function getMsUntilSameDayCutoff(zoned, cutoffHour) {
		if (!isSameDayShippingWeekday(zoned.weekday)) return null;

		var currentMinutes = zoned.hour * 60 + zoned.minute;
		var cutoffMinutes = cutoffHour * 60;
		if (currentMinutes >= cutoffMinutes) return null;

		return ((cutoffMinutes - currentMinutes) * 60 - zoned.second) * 1000;
	}

	function formatDeliveryCountdown(ms) {
		var totalSec = Math.max(0, Math.floor(ms / 1000));
		var hours = Math.floor(totalSec / 3600);
		var minutes = Math.floor((totalSec % 3600) / 60);
		var seconds = totalSec % 60;
		var parts = [];

		if (hours > 0) {
			parts.push(hours + ' t.');
		}
		if (minutes > 0 || hours > 0) {
			parts.push(minutes + ' min.');
		}
		if (hours === 0) {
			parts.push(seconds + ' sek.');
		}

		return parts.join(' ');
	}

	function initDeliveryEstimate(root) {
		var scope = root || document;
		var blocks = scope.querySelectorAll('[data-delivery-tooltip]');

		if (!window._deliveryEstimateOutsideClickBound) {
			window._deliveryEstimateOutsideClickBound = true;
			document.addEventListener('click', function (event) {
				document.querySelectorAll('.delivery-estimate.is-open').forEach(function (openBlock) {
					if (openBlock.contains(event.target)) return;
					openBlock.classList.remove('is-open');
					var openTrigger = openBlock.querySelector('[data-delivery-info]');
					if (openTrigger) {
						openTrigger.setAttribute('aria-expanded', 'false');
					}
				});
			});
		}

		blocks.forEach(function (block) {
			if (block.dataset.deliveryEstimateInit === 'true') return;

			var cutoffHour = parseInt(block.getAttribute('data-cutoff-hour') || '13', 10);
			var timeZone = block.getAttribute('data-timezone') || 'Europe/Copenhagen';
			var openEl = block.querySelector('[data-delivery-countdown-open]');
			var closedEl = block.querySelector('[data-delivery-countdown-closed]');
			var timeEl = block.querySelector('[data-delivery-countdown-time]');
			var trigger = block.querySelector('[data-delivery-info]');

			if (!openEl || !closedEl || !timeEl) return;

			block.dataset.deliveryEstimateInit = 'true';

			function updateCountdown() {
				var zoned = getZonedDateParts(timeZone);
				var remainingMs = getMsUntilSameDayCutoff(zoned, cutoffHour);

				if (remainingMs !== null && remainingMs > 0) {
					openEl.hidden = false;
					closedEl.hidden = true;
					timeEl.textContent = formatDeliveryCountdown(remainingMs);
					return;
				}

				openEl.hidden = true;
				closedEl.hidden = false;
			}

			updateCountdown();
			var intervalId = window.setInterval(updateCountdown, 1000);

			block._deliveryEstimateCleanup = function () {
				window.clearInterval(intervalId);
			};

			if (trigger) {
				trigger.addEventListener('click', function (event) {
					event.preventDefault();
					var isOpen = block.classList.toggle('is-open');
					trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
				});
			}
		});
	}

	document.addEventListener('change', function (event) {
		var target = event.target;
		if (!target || !target.matches('[data-terms-checkbox]')) return;
		var container = target.closest('[data-terms-acceptance]');
		setTermsState(container);
	});

	document.addEventListener('theme:cart:change', function () {
		initTermsAcceptance(document);
	});


	document.addEventListener('shopify:section:load', function (event) {
		initTopBarRotators(event.target);
		initCartDrawerCampaignGiftProgress(event.target);
		initCampaignGift(event.target);
		initProductCampaignGiftInfo(event.target);
		initSerierAlphabetNav(event.target);
		initEnergyLabelLinks(event.target);
		initProductImageClickToZoom(event.target);
		initMeasurementLightbox(event.target);
		initDeliveryEstimate(event.target);
	});

	document.addEventListener('shopify:section:unload', function (event) {
		var rotators = event.target.querySelectorAll('[data-top-bar-rotator]');
		rotators.forEach(function (rotator) {
			if (typeof rotator._topBarRotatorDestroy === 'function') {
				rotator._topBarRotatorDestroy();
			}
		});

		event.target.querySelectorAll('[data-delivery-tooltip]').forEach(destroyDeliveryEstimate);
	});

	function bootSearchmindCampaignGift() {
		initCampaignGift(document);
	}

	function bootSearchmind() {
		initTermsAcceptance(document);
		initTopBarRotators(document);
		initTopBarCampaignGiftTriggers();
		initCartDrawerCampaignGiftProgress(document);
		bootSearchmindCampaignGift();
		initProductCampaignGiftInfo(document);
		initSerierAlphabetNav(document);
		initEnergyLabelLinks(document);
		initProductImageClickToZoom(document);
		initMeasurementLightbox(document);
		initDeliveryEstimate(document);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bootSearchmind);
	} else {
		bootSearchmind();
	}

	window.addEventListener('load', bootSearchmindCampaignGift);
	document.addEventListener('page:load', bootSearchmind);

	// Open cart drawer when item is added to cart
	var addToCartTriggered = false;
	
	document.addEventListener('theme:cart:popdown', function (event) {
		addToCartTriggered = true;
		event.stopImmediatePropagation();
		event.preventDefault();
	}, true);

	document.addEventListener('theme:cart:change', function (event) {
		if (addToCartTriggered) {
			addToCartTriggered = false;
			
			// Small delay to ensure cart drawer content is updated
			setTimeout(function() {
				var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
				if (cartDrawer) {
					cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
						bubbles: false
					}));
				}
			}, 100);
		}
	});
})();
